'use client';

import { useEffect } from 'react';

import { GOOGLE_PUBLISHER_TAG_DEFAULTS } from './constants';

declare global {
  interface Window {
    googletag?: {
      cmd: Array<() => void>;
      display?: (divId: string) => void;
    };
  }
}

const isPremiumClient = (): boolean =>
  typeof window !== 'undefined' && window.__isPremiumUser === true;

type NextGooglePublisherTagAdAreaProps = {
  slotId?: string;
};

export const NextGooglePublisherTagAdArea = ({
  slotId = GOOGLE_PUBLISHER_TAG_DEFAULTS.slotId,
}: NextGooglePublisherTagAdAreaProps) => {
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_ENABLE_GOOGLE_PUBLISHER_TAG !== 'true') {
      return;
    }

    if (typeof window === 'undefined' || isPremiumClient()) {
      return;
    }

    if (!document.getElementById(slotId)) {
      return;
    }

    const googletag = window.googletag ?? { cmd: [] };
    window.googletag = googletag;
    googletag.cmd.push(() => {
      window.googletag?.display?.(slotId);
    });
  }, [slotId]);

  if (process.env.NEXT_PUBLIC_ENABLE_GOOGLE_PUBLISHER_TAG !== 'true') {
    return null;
  }

  if (isPremiumClient()) {
    return null;
  }

  return <div id={slotId} />;
};
